// extracted by mini-css-extract-plugin
module.exports = {"navItm":"pageSectionNavigation_navItm__cKHGs"};